import { render, staticRenderFns } from "./ContentSearchResult.vue?vue&type=template&id=06501582&scoped=true"
import script from "./ContentSearchResult.vue?vue&type=script&lang=ts"
export * from "./ContentSearchResult.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ContentSearchResult.vue?vue&type=style&index=0&id=06501582&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "06501582",
  "30dfc0de"
  
)

export default component.exports